module.exports = __webpack_public_path__ + "img/2-7-bellagio.f994d7a2.jpg";